module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "sm12": ""
    }
  }, [_vm._l((_vm.itemCount), function(n) {
    return _c('item', {
      key: ("item-" + n)
    })
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "large": "",
      "block": ""
    },
    on: {
      "click": function($event) {
        _vm.itemCount += 1
      }
    }
  }, [_vm._v("Add Another Item")])], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e69ec9a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/proxy/create/index.vue
// module id = 727
// module chunks = 1